import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Container } from '@sorare/core/src/atoms/layout/Container';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM } from '@sorare/core/src/atoms/typography';
import { HideSeriesBottomNav } from '@sorare/core/src/components/navigation/AppNavigation/HideSeriesBottomNav';
import {
  ANY_SPORT_SERIES_SQUAD_CREATE,
  ANY_SPORT_SERIES_SQUAD_JOIN,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { SquadBackground } from '#src/components/squad/SquadBackground/index.tsx';

import clubLogos from './assets/club-logos.webp';

const Root = styled(Vertical)`
  position: relative;
  min-height: calc(var(--100vh) - var(--current-stack-height));
  overflow: hidden;
  align-items: stretch;
  justify-content: flex-end;
  @media ${tabletAndAbove} {
    justify-content: center;
  }
`;

const ClubLogosImg = styled.img`
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 120%;
  max-width: none;
  height: auto;
  pointer-events: none;
  @media ${tabletAndAbove} {
    display: none;
  }
`;

const TopFade = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 230px;
  background: linear-gradient(to bottom, var(--c-black) 25%, transparent);
  z-index: 1;
`;

const StyledContainer = styled(Container)`
  backdrop-filter: blur(4px);
  @media ${tabletAndAbove} {
    backdrop-filter: none;
  }
`;

const BottomCard = styled(Vertical)`
  position: relative;
  padding: var(--triple-unit) 0;
  align-items: center;
`;

const CTARow = styled(Horizontal)`
  width: 100%;
  > * {
    flex: 1;
  }
`;

export const SquadCreateOrJoin = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Root>
      <SquadBackground />
      <ClubLogosImg src={clubLogos} alt="" />
      <TopFade />
      <StyledContainer maxWidth={600}>
        <BottomCard gap={3}>
          <Vertical gap={0.5} center>
            <BrandM>
              <FormattedMessage
                id="SquadCreateOrJoin.title"
                defaultMessage="Join or create a squad"
              />
            </BrandM>
            <BodyM color="var(--c-nd-700)" className="text-center">
              <FormattedMessage
                id="SquadCreateOrJoin.description"
                defaultMessage="Invite, play and compete with your friends"
              />
            </BodyM>
          </Vertical>
          <CTARow gap={2}>
            <Button
              size="large"
              color="secondary"
              to={generateSportContextPath(ANY_SPORT_SERIES_SQUAD_JOIN)}
            >
              <FormattedMessage {...glossary.join} />
            </Button>
            <Button
              size="large"
              color="primary"
              to={generateSportContextPath(ANY_SPORT_SERIES_SQUAD_CREATE)}
            >
              <FormattedMessage {...glossary.create} />
            </Button>
          </CTARow>
        </BottomCard>
      </StyledContainer>
      <HideSeriesBottomNav />
    </Root>
  );
};
